/**
 * Block 13 PR-G Phase 2 Step 2 — locale-dispatch для amount-in-words.
 *
 * Entry point для Step 4 `renderContractToPdf.ts` и Step 3 `contractTextRender.ts`.
 * `template.meta.lang` ('ru' | 'kk' | 'uz') → выбор соответствующего модуля.
 *
 * Output convention: words only (no currency word). Composition с currency
 * (e.g., "...тенге", "...теңге", "...so'm") handled by Step 3 при substitution
 * в template placeholders.
 *
 * Reference:
 *   - ADR-0025 §Q5
 *   - Block_13_PR_G_phase_0_planning.md Phase 2 Step 2
 */

import { amountInWordsKk } from './kk';
import type { AmountCurrency } from './ru';
import { amountInWordsRu } from './ru';
import { amountInWordsUz } from './uz';

export type { AmountCurrency } from './ru';
export type AmountLocale = 'ru' | 'kk' | 'uz';

export { amountInWordsKk, amountInWordsRu, amountInWordsUz };

/**
 * Dispatch by locale. Throws on invalid locale at runtime — Step 3 callers
 * pass `template.meta.lang` which is Zod-validated upstream, so this is a
 * defensive guard rather than expected path.
 */
export function amountInWords(n: number, locale: AmountLocale, currency: AmountCurrency): string {
  switch (locale) {
    case 'ru':
      return amountInWordsRu(n, currency);
    case 'kk':
      return amountInWordsKk(n, currency);
    case 'uz':
      return amountInWordsUz(n, currency);
    default: {
      const _exhaustive: never = locale;
      throw new Error(`amountInWords: unsupported locale ${String(_exhaustive)}`);
    }
  }
}
